"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductVariantName = exports.getEnrichedComboProduct = exports.getVariantProductOptionName = exports.isStoreProductAvailable = exports.getKitchenNameByLocale = exports.getLocaleEntity = void 0;
const domain_1 = require("@oolio-group/domain");
const AlternateNameUtils_1 = require("./AlternateNameUtils");
const lodash_1 = require("lodash");
const getLocaleEntity = (item, locale) => {
    const alternateNames = (item === null || item === void 0 ? void 0 : item.alternateNames) || [];
    const localeAlternateNameEncoded = alternateNames.find(x => locale == domain_1.LANGUAGE_LOCALE_MAP[x.locale]) ||
        alternateNames.find(x => ['en-US', 'en-GB', 'en-AU'].includes(domain_1.LANGUAGE_LOCALE_MAP[x.locale]));
    const localeValue = (0, AlternateNameUtils_1.decodeAlternateName)(localeAlternateNameEncoded);
    const displayName = (localeValue === null || localeValue === void 0 ? void 0 : localeValue.receipt) ||
        (localeValue === null || localeValue === void 0 ? void 0 : localeValue.display) ||
        (item === null || item === void 0 ? void 0 : item.name) ||
        '';
    const renamedItem = {
        ...item,
        name: displayName,
    };
    return renamedItem;
};
exports.getLocaleEntity = getLocaleEntity;
const getKitchenNameByLocale = (item, locale) => {
    var _a;
    return (_a = (0, AlternateNameUtils_1.decodeAlternateNameValuesToBase64)(item === null || item === void 0 ? void 0 : item.alternateNames).filter(x => x.locale === locale)[0]) === null || _a === void 0 ? void 0 : _a.kitchen;
};
exports.getKitchenNameByLocale = getKitchenNameByLocale;
const isStoreProductAvailable = (product, storeId) => {
    if (!product)
        return false;
    const { storesInventory } = product;
    const currentStoreInventory = storesInventory === null || storesInventory === void 0 ? void 0 : storesInventory[storeId];
    return !((currentStoreInventory === null || currentStoreInventory === void 0 ? void 0 : currentStoreInventory.isAvailable) === false);
};
exports.isStoreProductAvailable = isStoreProductAvailable;
const getVariantProductOptionName = (variantProduct) => {
    var _a, _b, _c;
    if (!variantProduct)
        return;
    const name = variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.name;
    const optionValues = (variantProduct === null || variantProduct === void 0 ? void 0 : variantProduct.optionValues) || [];
    if (variantProduct.isVariantProductNameChanged && optionValues.length == 1) {
        const postfixVal = ((_b = (_a = name === null || name === void 0 ? void 0 : name.split('-')) === null || _a === void 0 ? void 0 : _a.slice(1)) === null || _b === void 0 ? void 0 : _b.join(' - ')) || name;
        return postfixVal;
    }
    return (_c = optionValues.map(v => v.value).join(', ')) !== null && _c !== void 0 ? _c : '';
};
exports.getVariantProductOptionName = getVariantProductOptionName;
const getEnrichedComboProduct = (productMaps, variantMaps, comboProduct) => {
    comboProduct.modifierGroups.forEach(group => {
        var _a;
        group.products = (_a = group.products) === null || _a === void 0 ? void 0 : _a.filter(p => {
            var _a, _b;
            if ((_a = p.productDetail) === null || _a === void 0 ? void 0 : _a.variantId) {
                return variantMaps[p.productDetail.variantId] &&
                    p.productDetail.isSellable
                    ? true
                    : false;
            }
            return productMaps[(_b = p.productDetail) === null || _b === void 0 ? void 0 : _b.id] ? true : false;
        });
        const variantDetails = {};
        group.products.forEach(p => {
            var _a;
            const variantId = p.productDetail.variantId;
            if (variantId) {
                const variant = variantMaps[variantId];
                variantDetails[variantId] = {
                    id: variant.id,
                    name: variant.name,
                    options: variant.options,
                    products: (0, lodash_1.cloneDeep)([
                        ...(((_a = variantDetails === null || variantDetails === void 0 ? void 0 : variantDetails[variantId]) === null || _a === void 0 ? void 0 : _a.products) || []),
                        { ...p, productDetail: productMaps[p.id] },
                    ]),
                };
            }
        });
        const duplicateVariantIds = [];
        group.products = group.products.filter(product => {
            const variantId = product.productDetail.variantId;
            if (variantId && duplicateVariantIds.includes(variantId)) {
                return false;
            }
            else if (variantId) {
                product.variantDetail = variantDetails[variantId];
                product.name = variantDetails[variantId].name;
                product.id = variantDetails[variantId].id;
                product.price = null;
                duplicateVariantIds.push(variantId);
                delete product.productDetail;
                return true;
            }
            else {
                product.productDetail = productMaps[product.id];
                return true;
            }
        });
    });
    return comboProduct;
};
exports.getEnrichedComboProduct = getEnrichedComboProduct;
const getProductVariantName = (productName, variantName) => {
    return productName + '-' + variantName;
};
exports.getProductVariantName = getProductVariantName;
//# sourceMappingURL=product.js.map